import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AccountInvoice } from './../model/account-invoice';
import { AccountInvoiceDTO } from '../dto/account-invoice.dto';
import { RpcService } from './../../shared/http/rpc.service';
import { WindowService } from '../../shared/browser/window.service';

@Injectable()
export class AccountInvoicesService {
  constructor(private rpc: RpcService, private windowService: WindowService) {}

  public getAccountInvoices(): Observable<Array<AccountInvoice>> {
    return this.rpc
      .makeManagerCall('getAccountInvoices')
      .pipe(
        map((invoices: Array<AccountInvoiceDTO>) =>
          invoices.map(AccountInvoice.fromDto)
        )
      );
  }

  public requestAccountInvoiceUrl(
    accountInvoice: AccountInvoice
  ): Observable<string> {
    return this.rpc.makeManagerCall('createPaymentRequestForAccountInvoice', [
      accountInvoice.id,
      this.windowService.getCurrentLocation()
    ]);
  }
}
